import { ArrowLeft } from 'lucide-react';
import { useNavigate, Link } from 'react-router-dom';

export const ConfidentialitePage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#09090b]">
      <header className="sticky top-0 z-50 bg-[#09090b]/95 backdrop-blur-md border-b border-zinc-800">
        <div className="max-w-3xl mx-auto px-4 py-3 flex items-center gap-3">
          <button onClick={() => navigate('/')} className="flex items-center gap-2 text-zinc-400 hover:text-white transition">
            <ArrowLeft className="w-5 h-5" />
            <img src="/logo-youmi.png" alt="YOUMI GREEN VTC" className="w-10 h-10" />
            <span className="text-lg font-bold text-white font-['Outfit']">YOUMI <span className="text-emerald-500">GREEN</span></span>
          </button>
        </div>
      </header>

      <div className="max-w-3xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-white font-['Outfit'] mb-8" data-testid="confidentialite-title">Politique de Confidentialité</h1>
        
        <div className="space-y-8 text-zinc-300 leading-relaxed">
          <section>
            <h2 className="text-xl font-semibold text-white mb-3">Responsable du traitement</h2>
            <p>
              <strong className="text-white">YOUMI GREEN VTC</strong>, SASU, SIRET 889 633 020 00017, 
              1 rue du Bel Air, 91000 Évry-Courcouronnes.
            </p>
            <p className="mt-2">Représentant : <strong className="text-white">MELLOUK Youssef</strong></p>
            <p>Email : <a href="mailto:contact@youmigreenvtc.com" className="text-emerald-400 hover:underline">contact@youmigreenvtc.com</a></p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">Données collectées</h2>
            <ul className="list-disc list-inside space-y-1">
              <li>Nom, prénom</li>
              <li>Téléphone, email</li>
              <li>Adresse de départ et destination</li>
              <li>Date et heure de course</li>
              <li>Données de paiement (traitées de manière sécurisée)</li>
              <li>Données de navigation</li>
            </ul>
            <p className="mt-2 text-emerald-400 font-medium">Aucune donnée sensible n'est collectée.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">Finalités</h2>
            <ul className="list-disc list-inside space-y-1">
              <li>Gestion des réservations</li>
              <li>Communication client</li>
              <li>Facturation</li>
              <li>Amélioration des services</li>
              <li>Respect des obligations légales</li>
              <li>Communications commerciales uniquement avec consentement</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">Base légale</h2>
            <ul className="list-disc list-inside space-y-1">
              <li><strong className="text-white">Exécution du contrat</strong> pour la prestation de transport</li>
              <li><strong className="text-white">Obligation légale</strong> pour la facturation</li>
              <li><strong className="text-white">Intérêt légitime</strong> pour l'amélioration des services</li>
              <li><strong className="text-white">Consentement</strong> pour les communications commerciales</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">Durée de conservation</h2>
            <ul className="list-disc list-inside space-y-1">
              <li>Données clients actifs : conservées pendant la relation commerciale</li>
              <li>Clients inactifs : suppression après 3 ans</li>
              <li>Données de facturation : 10 ans (obligation légale)</li>
              <li>Cookies : 13 mois maximum</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">Destinataires</h2>
            <p>
              Données destinées exclusivement à YOUMI GREEN VTC. Transmises uniquement aux prestataires 
              techniques nécessaires :
            </p>
            <ul className="list-disc list-inside space-y-1 mt-2">
              <li>Prestataire de paiement (Stripe)</li>
              <li>Hébergeur (Emergent)</li>
              <li>WhatsApp Business (Meta)</li>
            </ul>
            <p className="mt-2">
              Ces prestataires sont soumis à des obligations strictes de confidentialité.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">Vos droits</h2>
            <p>
              Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez d'un droit :
            </p>
            <ul className="list-disc list-inside space-y-1 mt-2">
              <li>D'<strong className="text-white">accès</strong> à vos données</li>
              <li>De <strong className="text-white">rectification</strong></li>
              <li>D'<strong className="text-white">effacement</strong></li>
              <li>De <strong className="text-white">limitation</strong> du traitement</li>
              <li>De <strong className="text-white">portabilité</strong></li>
              <li>D'<strong className="text-white">opposition</strong></li>
            </ul>
            <p className="mt-3">
              Pour exercer ces droits : <a href="mailto:contact@youmigreenvtc.com" className="text-emerald-400 hover:underline">contact@youmigreenvtc.com</a>
            </p>
            <p className="mt-1">Réponse garantie sous 1 mois.</p>
            <p className="mt-1">
              Réclamation possible auprès de la CNIL sur{' '}
              <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-emerald-400 hover:underline">www.cnil.fr</a>
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">Cookies</h2>
            <p>
              Le site utilise uniquement des cookies techniques nécessaires au fonctionnement et des cookies 
              Google Ads pour le suivi des conversions publicitaires. Aucun cookie publicitaire additionnel 
              sans consentement.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">Sécurité</h2>
            <p>
              Toutes les mesures techniques appropriées sont mises en œuvre pour protéger vos données. 
              Les paiements sont chiffrés via SSL/TLS.
            </p>
          </section>

          <p className="text-zinc-500 text-sm pt-4 border-t border-zinc-800">Dernière mise à jour : 15 mars 2026</p>
        </div>

        <div className="mt-12 flex gap-4 text-sm">
          <Link to="/mentions-legales" className="text-emerald-400 hover:underline">Mentions légales</Link>
          <Link to="/cgv" className="text-emerald-400 hover:underline">CGV</Link>
        </div>
      </div>
    </div>
  );
};

export default ConfidentialitePage;
